import { FormProvider } from 'react-hook-form';
import { useCreateClientAdminUserModal } from './hooks';
import { CreateClientAdminUserModalPresentation } from './presentations';

type Props = {
  onClose: () => void;
  handleMutateUsers: () => void;
};

export const CreateClientAdminUserModal: React.FC<Props> = ({ onClose, handleMutateUsers }) => {
  const {
    state: { methods },
    actions: { handleSubmit },
  } = useCreateClientAdminUserModal({ handleMutateUsers });

  return (
    <FormProvider {...methods}>
      <CreateClientAdminUserModalPresentation onClose={onClose} onConfirm={handleSubmit} />
    </FormProvider>
  );
};
